import React, { useState, useEffect, useRef } from "react";
import "./PhoneInput.css";

// Derive flag emoji from ISO code (e.g. "IN" → 🇮🇳)
const getFlagEmoji = (isoCode) => {
  if (!isoCode || isoCode.length !== 2) return "🌐";
  return isoCode
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");
};

const PhoneInput = ({
  countryCodes = [],
  dialCode,
  onDialCodeChange,
  mobileNumber,
  onMobileNumberChange,
  placeholder = "Mobile Number (Optional)",
  error = "",
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  const selected = countryCodes.find((c) => c.dialCode === dialCode) || null;

  const filtered = countryCodes.filter(
    (c) =>
      c.isoCode.toLowerCase().includes(search.toLowerCase()) ||
      c.dialCode.includes(search)
  );

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (code) => {
    onDialCodeChange(code.dialCode);
    setOpen(false);
    setSearch("");
  };

  return (
    <div>
      <div className="phone-input-row" ref={ref}>
        {/* Country Code Dropdown */}
        <div className="country-code-dropdown">
          <div
            className={`country-code-trigger ${open ? "open" : ""}`}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className="cc-flag">
              {selected ? getFlagEmoji(selected.isoCode) : "🌐"}
            </span>
            <span className="cc-dial">
              {selected ? selected.dialCode : "+91"}
            </span>
            <span className="cc-arrow">▾</span>
          </div>

          {open && (
            <div className="country-code-menu">
              <input
                className="country-code-search"
                placeholder="Search country..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus
              />
              <div className="country-code-list">
                {filtered.length > 0 ? (
                  filtered.map((c) => (
                    <div
                      key={c.id}
                      className={`country-code-option ${c.dialCode === dialCode ? "selected" : ""}`}
                      onClick={() => handleSelect(c)}
                    >
                      <span className="cc-flag">{getFlagEmoji(c.isoCode)}</span>
                      <span className="cc-iso">{c.isoCode}</span>
                      <span className="cc-dial">{c.dialCode}</span>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "12px", color: "#999", fontSize: "13px" }}>
                    No results
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Mobile Number Input */}
        <input
          type="tel"
          className="phone-number-input"
          value={mobileNumber}
          onChange={(e) => onMobileNumberChange(e.target.value.replace(/[^\d]/g, ""))}
          placeholder={placeholder}
          maxLength={15}
        />
      </div>
      {error && (
        <span style={{ display: "block", color: "#dc2626", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </span>
      )}
    </div>
  );
};

export default PhoneInput;
